import React from "react";
import "./Transport.scss";
import OnScrollAnimationWrapper from "../common/OnScrollAnimationWrapper";

const mapEmbeded = `<div style="width: 100%"><iframe width="100%" height="320" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" src="https://maps.google.com/maps?width=100%25&amp;height=320&amp;hl=en&amp;q=%D0%A0%D0%B5%D1%81%D1%82%D0%BE%D1%80%D0%B0%D0%BD%D1%82%20%E2%80%9E%D0%9F%D0%B5%D1%87%D0%BA%D0%B0%D1%82%D0%B0%E2%80%9C,%20%D1%81%D0%B2.%20%D1%81%D0%B2.%20%D0%9A%D0%BE%D0%BD%D1%81%D1%82%D0%B0%D0%BD%D1%82%D0%B8%D0%BD%20%D0%B8%20%D0%95%D0%BB%D0%B5%D0%BD%D0%B0+(%D0%A0%D0%B5%D1%81%D1%82%D0%BE%D1%80%D0%B0%D0%BD%D1%82%20%E2%80%9E%D0%9F%D0%B5%D1%87%D0%BA%D0%B0%D1%82%D0%B0%E2%80%9C)&amp;t=&amp;z=16&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"><a href="https://www.mapsdirections.info/de/evolkerung-auf-einer-karte-berechnen/">Demografie Karte Deutschland</a></iframe></div>`;

export default function Transport({ t }) {
  return (
    <div className="bg-white">
      <div className="p-top-8 p-bottom-8 transport bg-beige" id="transport">
        <div className="container p-top-4 text-primary">
          <h3 className="text-center m-bottom-4 m-top-1 text-primary">{t.contactQuestion}</h3>
          <div className="flex flex-justify-center text-center m-bottom-6">
            <div className="col-12 col-8-xl">
              <p className="text-md m-bottom-2 text-justify-xs text-justify-sm text-primary">
                {t.contactText}
              </p>
              <p className="m-top-2 m-bottom-2 text-lg m-bottom-4 text-primary">
                {t.weddingAgent}
                <br />
                <i className="fa-solid fa-phone m-right-1 m-top-1 text-primary"></i><span className="font-weight-700 m-top-1 text-primary">+359 890 111 439</span>
              </p>
            </div>
          </div>
          <div className="m-bottom-8 m-inline-12 m-inline-1-xs" style={{ overflow: 'hidden' }}>
            <svg 
              width="100%" 
              height="20" 
              viewBox="0 0 400 20" 
              preserveAspectRatio="none"
              style={{ display: 'block', maxWidth: '100%' }}
            >
              <path 
                d="M0,10 C30,6 60,14 100,10 C140,6 170,14 200,10 C230,6 260,14 300,10 C340,6 370,14 400,10" 
                fill="none" 
                stroke="currentColor" 
                strokeWidth="1.5"
                strokeLinecap="round"
                className="text-primary"
              />
            </svg>
          </div>
          <OnScrollAnimationWrapper
            animation={"animation-slide-fade-in-down"}
            triggerOnce={false}
            classNameInitialState={`opacity-0 text-animation-slide-in`}
          >
            <h1 className="text-center m-bottom-4 text-primary">{t.howToGetThere}</h1>
          </OnScrollAnimationWrapper>
          <div className="flex flex-justify-center text-center">
            <div className="col-12 col-8-xl">
              <p className="text-md m-bottom-2 text-justify-xs text-justify-sm">
                {t.locationDescription}
                {" "}
                <span className="font-weight-700">{t.hotelInfo}{" "}</span>
                {t.hotelDistance}
              </p>
              <p className="m-top-2 m-bottom-2 text-lg m-bottom-4 text-primary">
                {t.bride}
                <br />
                <i className="fa-solid fa-phone m-right-1 m-top-1 text-primary"></i><span className="font-weight-700 m-top-1 text-primary">+359 898 637 937</span>
              </p>
            </div>
          </div>
          <div className="flex flex-justify-center gap-5-xl">
            <div className="col-12 col-6-xl m-top-2">
              <h4 className="text-center font-body m-block-1 font-weight-700 text-primary">{t.restaurantNameShort}</h4>
              <h6 className="text-center font-heading m-bottom-1 text-primary">{t.locationShort}</h6>
              <p className="text-xs text-center text-primary">{t.mapNote}</p>
              <div className="display-block m-auto p-top-3 p-bottom-5">
                <div
                  className="map-location"
                  dangerouslySetInnerHTML={{ __html: mapEmbeded }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
